const module = { name: 'theater/showtimes/desktop.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { fd_location as fd_location_updateLocation_getLocation } from 'require-global';

const { updateLocation, getLocation } = fd_location_updateLocation_getLocation;


import { default as locationFormCreation } from 'swug-fdRequire-call:fd-location/form/creation';



import { Fandango_debugLog as debugLog } from 'require-core';



import { default as theater_shared_tdpLocationHelper_updateLocationURL_resolveUrlLocation } from 'swug-fdRequire-call:theater/shared/tdpLocationHelper';

const { updateLocationURL, resolveUrlLocation } = theater_shared_tdpLocationHelper_updateLocationURL_resolveUrlLocation;


import { default as calendarUI } from 'swug-fdRequire-call:theater/showtimes/calendarUI';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



import { default as historyStates } from 'swug-fdRequire-call:movie/shared/historyStates';



import { default as movieShowtimeGroupings } from 'swug-fdRequire-call:theater/showtimes/movieShowtimeGroupings';



import { default as openChainFilter } from 'swug-fdRequire-call:theater/showtimes/openChainFilterDesktop';



import { default as theaterConcessionAmenity } from 'swug-fdRequire-call:theater/shared/theaterConcessionAmenity';



import { shared_global_globalTooltipModule as globalTooltipModule } from 'require-global';



const Selectors = {
    LOCATION: '#theaters-module-location',
    SUB_NAV_LOCATION: '.js-subnav__user-location',
    GLOBAL_TOOLTIP_PLACEHOLDER: '#global-tooltip-placeholder-showtimes',
}


const Styles = {
    GLOBAL_TOOLTIP_SHOWTIMES: 'global-tooltip__container--tsp-desktop',
}
function updateSubNavLocation(location) {
    const el = document.querySelector(Selectors.SUB_NAV_LOCATION);
    let displayText = location.name || location.postalCode || '';
    displayText = displayText.replace(/,\s*$/, '');
    if (location.postalCode && !location.city) {
        displayText = displayText.toUpperCase();
    }
    return el.innerText = displayText;
}
function load() {
    const location = getLocation();
    updateLocation(location);
    calendarUI.renderCalendar();
    updateSubNavLocation(location);
    hearts.init();
    movieShowtimeGroupings.init((clientSideTheaters) => {
        theaterConcessionAmenity.init(clientSideTheaters);
    });
    openChainFilter.init();
}
function onLocationChange() {
    const location = getLocation();
    historyStates.push(historyStates.HistoryEventTypes.LOCATION, location);
    updateLocationURL();
    load();
}
function run() {
    checkDependencies(module.name, debugLog);
    const tooltipOpts = {
        selector: Selectors.GLOBAL_TOOLTIP_PLACEHOLDER,
        page: globalTooltipModule.Pages.THEATER_SHOWTIMES,
        overrideClass: Styles.GLOBAL_TOOLTIP_SHOWTIMES,
    };
    globalTooltipModule.initInline(tooltipOpts);
    locationFormCreation.init({
        trigger: '#btn-location',
        dropdown: {
            name: 'desktopTheaterShowtimesModule',
            relativeParent: '#theaters-module-location',
        }
    });
    locationFormCreation.attach(onLocationChange);
    resolveUrlLocation(load);
}
document.addEventListener('DOMContentLoaded', run);
export default module.exports;